import { createSlice } from "@reduxjs/toolkit";
import { getEnrollmentAgreementListAPI } from "../../services/getEnrollmentAgreementList";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getEnrollmentAgreementListSlice = createSlice({
  name: "getEnrollmentAgreementList",
  initialState,
  reducers: {
    getEnrollmentAgreementListInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    getEnrollmentAgreementListInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "";
    },
    getEnrollmentAgreementListInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    getEnrollmentAgreementListInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getEnrollmentAgreementListHandler = (payload) => async (dispatch) => {
  try {
    dispatch(
      getEnrollmentAgreementListAction.getEnrollmentAgreementListInfo(payload),
    );
    const response = await getEnrollmentAgreementListAPI(payload);
    dispatch(
      getEnrollmentAgreementListAction.getEnrollmentAgreementListInfoSuccess(
        response,
      ),
    );
  } catch (e) {
    dispatch(
      getEnrollmentAgreementListAction.getEnrollmentAgreementListInfoFailure(
        e?.response?.data?.message || e?.message || String(e),
      ),
    );
  }
};

export default getEnrollmentAgreementListSlice.reducer;
export const getEnrollmentAgreementListAction = getEnrollmentAgreementListSlice.actions;

